module.exports = __webpack_public_path__ + "img/air-quality-lg.3cf79351.svg";